'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/* ----------------------- Contexts ----------------------- */
var FormControllerContext = /*#__PURE__*/React__default["default"].createContext({});
var FormApiContext = /*#__PURE__*/React__default["default"].createContext({});
var FormStateContext = /*#__PURE__*/React__default["default"].createContext({});
var MultistepStepContext = /*#__PURE__*/React__default["default"].createContext();
var MultistepApiContext = /*#__PURE__*/React__default["default"].createContext();
var MultistepStateContext = /*#__PURE__*/React__default["default"].createContext();
var ArrayFieldStateContext = /*#__PURE__*/React__default["default"].createContext();
var ArrayFieldApiContext = /*#__PURE__*/React__default["default"].createContext();
var ArrayFieldItemApiContext = /*#__PURE__*/React__default["default"].createContext();
var ArrayFieldItemStateContext = /*#__PURE__*/React__default["default"].createContext();
var RelevanceContext = /*#__PURE__*/React__default["default"].createContext();
var RadioGroupContext = /*#__PURE__*/React__default["default"].createContext();
var ScopeContext = /*#__PURE__*/React__default["default"].createContext();
var InformedContext = /*#__PURE__*/React__default["default"].createContext();

exports.ArrayFieldApiContext = ArrayFieldApiContext;
exports.ArrayFieldItemApiContext = ArrayFieldItemApiContext;
exports.ArrayFieldItemStateContext = ArrayFieldItemStateContext;
exports.ArrayFieldStateContext = ArrayFieldStateContext;
exports.FormApiContext = FormApiContext;
exports.FormControllerContext = FormControllerContext;
exports.FormStateContext = FormStateContext;
exports.InformedContext = InformedContext;
exports.MultistepApiContext = MultistepApiContext;
exports.MultistepStateContext = MultistepStateContext;
exports.MultistepStepContext = MultistepStepContext;
exports.RadioGroupContext = RadioGroupContext;
exports.RelevanceContext = RelevanceContext;
exports.ScopeContext = ScopeContext;
